import React from 'react';
import clsx from 'clsx';

import { ReactComponent as FSIcon } from '../../assets/svg/expand-grey.svg';
import { ReactComponent as CloseIcon } from '../../assets/svg/close-grey.svg';

import styles from './ModalContainer.module.scss';

const ModalContainer = ({
  background,
  handleClose,
  children,
  maxWidth,
  isMapContainer,
  isConsentModal,
  isErrorModal,
  isOrientationModal,
  isFullScreen,
  isFullScreenActive,
  setIsFullScreenActive,
  isFullHeight,
  ...restProps
}) => (
  <div
    className={clsx(
      styles.modalContainer,
      isMapContainer ? styles.mapContainer : '',
      isConsentModal ? styles.consentContainer : '',
      isErrorModal ? styles.errorModalContainer : '',
      isFullScreen ? styles.fullScreen : '',
      isFullScreenActive ? styles.fullScreenActive : '',
      isFullHeight ? styles.fullHeight : '',
      restProps ? restProps.className : ''
    )}
    style={{
      background,
      maxWidth,
      overflow: restProps?.isScroll ? 'auto' : 'unset',
    }}
  >
    {isConsentModal && (
      <div className={styles.iconsWrapper}>
        {isFullScreen && (
          <div
            className={styles.fullscreenIconWrapper}
            onClick={() => setIsFullScreenActive(!isFullScreenActive)}
            aria-hidden
          >
            <FSIcon />
          </div>
        )}
        <div className={styles.closeIconWrapper} onClick={handleClose} aria-hidden>
          <CloseIcon />
        </div>
      </div>
    )}
    {(isErrorModal || restProps?.isPasswordUpdateModal) && !isOrientationModal && (
      <div
        className={clsx(
          isErrorModal ? styles.errorCloseIconWrapper : '',
          restProps?.isPasswordUpdateModal ? styles.passwordCloseIconWrapper : ''
        )}
        onClick={handleClose}
        aria-hidden
      >
        <CloseIcon />
      </div>
    )}
    {children}
  </div>
);

export default ModalContainer;
